module.exports = __webpack_public_path__ + "img/format_indent_decrease.acafa40c.svg";